import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Custom Components
import ModelTable from "UI/Table/ModelTable";
import TableCard from "UI/Table/TableCard";
import TableCardContent from "UI/Table/TableCardContent";
import TableButtonEdit from "UI/Table/ActionButtons/TableButtonEdit";
import DialogContext from "UI/DialogContext/DialogContext";
import withRedirect from "Components/withRedirect";
import model from "Models/komitenti";
import dataController from "Lib/dataController";
import KomitentiDialog from "./KomitentiDialog";
import KomitentiList from "./KomitentiList";
import UserContext from "Components/UserContext/UserContext";

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them

function KomitentiTable(props) {
  const dialogContext = useContext(DialogContext);
  const userContext = useContext(UserContext);
  const { t } = useTranslation();
  const [records, setRecords] = useState([]);

  const { redirect } = props;

  const dc = new dataController(model, "prijevoznici/" + userContext.subjectId + "/komitenti");

  useEffect(() => {
    refreshRecords();
  }, [userContext.subjectId]);

  const handleEdit = (evt, sel) => {
    const selId = parseInt(sel[0], 10);
    const record = records[selId];
    const id = record["id"];

    redirect(`/p/komitenti/${id}`);
  };

  const handleAdd = () => {
    dialogContext.showDialog(KomitentiDialog, {
      dc: dc,
      from: "default",
      onClose: handleDialogClose,
      mode: "insert"
    });
  };

  const handleDialogClose = (result) => {
    if (result.dataChanged) {
      refreshRecords();
    }
  };

  const refreshRecords = () => {
    dc.GetData().then((resp) => {
      if (resp.success) {
        setRecords(resp.data);
      }
    });
  };

  const handleRowAction = function(action, id) {
    if (action === "edit") {
      redirect(`/p/komitenti/${id}`);
    }
  }

  const allowRowAction = function(action, id) {
    return true;
  }

  return (
    <TableCard>
      <TableCardContent>
        <ModelTable
          title={t("titles.komitenti")}
          records={records}
          dc={dc}
          allowExport={true}
          allowFilter={true}
          allowAdd={true}
          addLabel={t("buttons.new_m")}
          allowSelection={"none"}
          handleAdd={handleAdd}
          handleRefresh={refreshRecords}
          onRowAction={handleRowAction}
          allowRowAction={allowRowAction}
          onDoubleClick={(id) => handleRowAction("edit", id)}
        />
      </TableCardContent>
    </TableCard>
  );
}

export default withRedirect(KomitentiTable);
